import { useId } from 'react';
import { Alert, AlertTitle, FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './ManualReplyPauseSetting.css';

// These channels deliver native outgoing replies as echoes, including greetings.
const NATIVE_REPLY_PLATFORMS = { facebook: 'Facebook Messenger', instagram: 'Instagram', whatsapp: 'WhatsApp Business' };

export default function ManualReplyPauseSetting({ checked, onChange, platform, disabled = false }) {
  const { t } = useTranslation();
  const warningId = useId();
  const showWarning = checked && Boolean(NATIVE_REPLY_PLATFORMS[platform]);
  const help = platform === 'whatsapp' ? 'pause_ai_on_manual_reply_whatsapp_help'
    : ['facebook', 'instagram'].includes(platform) ? 'pause_ai_on_manual_reply_meta_help'
      : 'pause_ai_on_manual_reply_help';
  return <div className="manual-reply-pause-section">
    <div className="manual-reply-pause-label">{t('connect_manual_replies_label')}</div>
    <FormControlLabel
      control={<Switch checked={checked} onChange={event => onChange(event.target.checked)} disabled={disabled}
        inputProps={{ 'aria-describedby': showWarning ? warningId : undefined }}
        sx={{
          width: 40, height: 24, padding: '5px 0', marginRight: '12px', flexShrink: 0,
          '& .MuiSwitch-switchBase': { padding: '2px' },
          '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(16px)', color: '#5616ea' },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#5616ea' },
          '& .MuiSwitch-switchBase.Mui-focusVisible .MuiSwitch-thumb': { outline: '2px solid #5616ea', outlineOffset: '3px' },
        }} />}
      label={t('pause_ai_on_manual_reply')}
      sx={{ margin: 0 }}
    />
    <p style={{ fontSize: '0.85rem', color: '#666', lineHeight: 1.5, margin: '8px 0 0' }}>{t(help)}</p>
    {showWarning && <Alert severity="warning" id={warningId}
      sx={{ mt: 2, backgroundColor: '#fff9e1', color: '#554002', border: '1px solid #ffc107',
        borderLeft: '4px solid #ffc107', borderRadius: '8px', fontSize: '0.85rem', lineHeight: 1.5,
        alignItems: 'center', '& .MuiAlert-icon': { color: '#554002', opacity: 1, padding: 0 },
        '& .MuiAlert-message': { minWidth: 0 } }}>
      <AlertTitle sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.4 }}>
        {t('pause_ai_automatic_replies_warning_title')}
      </AlertTitle>
      {t('pause_ai_automatic_replies_warning', { platform: NATIVE_REPLY_PLATFORMS[platform] })}
    </Alert>}
  </div>;
}
